import { jwtDecode } from 'jwt-decode';
import { tokenStorage } from './tokenStorage';

/**
 * Get the current user session from stored tokens
 * @returns {UserSession|null} User session or null if not authenticated
 */
export function getUserSession() {
    const accessToken = tokenStorage.getAccessToken();
    const idToken = tokenStorage.getIdToken();

    if (!accessToken || !idToken) {
        return null;
    }

    try {
        const decodedToken = jwtDecode(accessToken);

        return {
            user: {
                id: decodedToken.sub,
                sub: decodedToken.sub,
                email: decodedToken.email || '',
                name: decodedToken.name || '',
                given_name: decodedToken.given_name,
                family_name: decodedToken.family_name,
                email_verified: decodedToken.email_verified || false,
                preferred_username: decodedToken.preferred_username,
                phoneNumber: decodedToken.phoneNumber
            },
            access_token: accessToken,
            id_token: idToken
        };
    } catch (error) {
        console.error('Error decoding token:', error);
        return null;
    }
}

/**
 * Check if user is authenticated (has tokens that can be used or refreshed)
 * @returns {boolean} True if user has valid tokens or refresh token available
 */
export function isAuthenticated() {
    const accessToken = tokenStorage.getAccessToken();
    const refreshToken = tokenStorage.getRefreshToken();
    
    // User is authenticated if they have an access token (valid or expired but refreshable)
    // or if they have a refresh token that can be used to get a new access token
    if (!accessToken && !refreshToken) {
        return false;
    }
    
    // If access token exists and is not expired, user is authenticated
    if (accessToken && !tokenStorage.isTokenExpired()) {
        return true;
    }
    
    // If access token is expired but we have a refresh token, user is still considered authenticated
    // The actual token refresh will happen in getValidAccessToken()
    if (refreshToken) {
        return true;
    }
    
    return false;
}
